<div *ngIf="type=='Off_Represantative Briefly'">
  <div id="print-section" style="margin-top: 50px;">
    <table class="table table-bordered">
      <thead style=" background-color: #e0e0e0;font-size: 18px;">
        <tr>

          <th colspan="12"
            style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: center; padding: 5px;width:0%;">
            <span style="text-align:center;">ADVT Registration Report - Briefly Off-Represantative</span>
          </th>
        </tr>

        <tr>
          <th colspan="5"
            style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: left; padding: 5px;width:0%;">
            <span style="text-align:center;">हिंदुस्तान
              प्रकाशन संस्था-विवेक साप्ताहिक</span>
          </th>
          <th colspan="7"
            style="border: 0px solid #fdfdfd;border-bottom: 1px solid #000;border-top: 1px solid #000; font-size: medium; text-align: center; padding: 5px;width:0%;border-right: 1px solid #000;">
            <span style="text-align:center;"><span><strong>अंकाचे कॅटेगरी :</strong> &nbsp; {{issue_cat}} </span><span
                style="text-align: end;"> Date : From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date:
                'dd-MM-yyyy' }}&nbsp;&nbsp;&nbsp; <span style="text-align: end;"><strong>दिनांक :</strong> {{today1}}
                </span></span></span>
          </th>
          <!-- <th colspan="3" style="border:1px solid #000;font-size: 14px;" class="br-bottom br-right br-top"> Date : From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}&nbsp;&nbsp;&nbsp;   <span><strong>दिनांक :</strong> {{today1}} </span>
          <span>   <strong></strong></span></th>                    -->
          <!-- <th colspan="1" style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-right: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
            <span><strong>दिनांक :</strong> {{today1}} </span>
          <span>   <strong></strong></span>
          </th> -->
        </tr>
        <tr>
          <th colspan="5"
            style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
            <strong>अंकाचे नाव :</strong> &nbsp; {{newissuedatepp}}


          </th>

          <th colspan="5"
            style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
            <strong>अंकाची दिनांक :</strong> &nbsp; {{issuedatepp | date : "dd-MM-yyy"}}

          </th>
          <th colspan="7"
            style="border: 0px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; font-size: medium; text-align: left; padding: 5px;width:0%;">
            <strong></strong>


          </th>
        </tr>


        <ng-container>
          <tr>

          </tr>
          <tr>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px;  width: 0%;font-weight: bold;font-size: 16px;">
              Sr</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px;  width: 0%;font-weight: bold;font-size: 16px;">
              Advt Name</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px;  width: 0%;font-weight: bold;font-size: 16px;">
              Client</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px;  width: 0%;font-weight: bold;font-size: 16px;">
              Representative</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px; font-weight: bold;font-size: 16px;">
              Advt. Size</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px; font-weight: bold;font-size: 16px; text-align: end;width:0%;">
              Advt<br>Amt</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px;  font-weight: bold;font-size: 16px; text-align: end;width:0%;">
              Net<br>Amt</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px; font-weight: bold;font-size: 16px; text-align: end;width:0%;">
              Before<br>Gst</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px;  font-weight: bold;font-size: 16px; text-align: end;width:0%;">
              GST<br>Amt</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px; font-weight: bold;font-size: 16px; text-align: end;width:0%;">
              Total<br>Amt</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px; font-weight: bold;font-size: 16px; text-align: end;width:0%;">
              Receive<br>Amt</th>
            <th colspan="1"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; height: 40px;  font-weight: bold;font-size: 16px; text-align: end;width:0%;">
              Pending<br>Amt</th>
          </tr>
        </ng-container>

      </thead>
      <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
      <tbody>
        <ng-container *ngFor="let item2 of inDetailsRegReportbtoff; let i = index">
          <tr>
            <td colspan="3"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;  width: 1%;font-weight: bold;font-size: 16px;"
              class="br-bottom br-right" class=" br-right br-top br-bottom">Off-Represantative</td>
            <td colspan="2"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;   width: 1%;font-size: 16px;"
              class=" br-right br-top br-bottom">{{item2.off_rep_name}}</td>
            <td colspan="7"
              style="border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;   width: 1%;"
              class=" br-right br-top br-bottom"></td>

          </tr>
          <ng-container *ngFor="let item1 of item2.rep_data; let i = index">
            <tr>
              <td colspan="4"
                style=" border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;font-size: 15px;   width: 1%;"
                class=" br-right br-top br-bottom" class=" br-right br-top br-bottom"> <span
                  style="font-weight: bold;">Rep - </span>{{item1.rep_name}}</td>
              <!-- <td colspan="1" style=" border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;   width: 1%;"class=" br-right br-top br-bottom" class=" br-right br-top br-bottom">{{item1.rep_name}}</td> -->
              <td colspan="4"
                style=" border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;font-size: 15px;   width: 1%;"
                class=" br-right br-top br-bottom" class=" br-right br-top br-bottom"><span
                  style="font-weight: bold;">Mobile No - </span>{{item1.rep_mob_no}}</td>
              <!-- <td colspan="1" style=" border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;   width: 1%;"class=" br-right br-top br-bottom" class=" br-right br-top br-bottom">{{item1.rep_mob_no}}</td> -->
              <td colspan="4"
                style=" border: none; border-left: 1px solid #000;border-top: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;   width: 1%;"
                class=" br-right br-top br-bottom" class=" br-right br-top br-bottom"></td>
            </tr>

            <ng-container *ngFor="let item of item1.advt_data; let i = index">
              <tr style="width: 100%;">
                <td colspan="1"
                  style="border:none;border-left: 1px solid #000;border-right: 1px solid #000; font-weight: bold;font-size: 14px;text-align:center"
                  class=" br-right">{{item.advtsizeno}}</td>
                <td colspan="1" style="border:none;border-right: 1px solid #000;font-size: 14px;font-weight: bold;"
                  class=" br-right">{{item.advt_name| slice:0:30 }}</td>
                <td colspan="1" style="border:none;border-right: 1px solid #000;font-size: 14px;" class=" br-right">
                  {{item.client}}</td>
                <td colspan="1" style="border:none;border-right: 1px solid #000;font-size: 14px;" class=" br-right">
                  {{item.rep_name}}</td>
                <td colspan="1" style="border:none;border-right: 1px solid #000;font-size: 14px; " class=" br-right">
                  {{item.advtsize| slice:0:25 }}</td>
                <td colspan="1"
                  style="border:none;border-right: 1px solid #000;font-size: 14px; text-align: end;width:0%;"
                  class=" br-right">{{item.advt_amt}}</td>
                <td colspan="1"
                  style="border:none;border-right: 1px solid #000;font-size: 14px; text-align: end;width:0%;"
                  class=" br-right">{{item.amount}}</td>
                <td colspan="1"
                  style="border:none;border-right: 1px solid #000;font-size: 14px; text-align: end;width:0%;"
                  class=" br-right">{{item.beforegst_amt}}</td>
                <td colspan="1"
                  style="border:none;border-right: 1px solid #000;font-size: 14px; text-align: end;width:0%;"
                  class=" br-right">{{item.gst}}</td>
                <td colspan="1"
                  style="border:none;border-right: 1px solid #000;font-size: 14px; text-align: end;width:0%;background-color: #F7BEA2;"
                  class=" br-right">{{item.amount}}</td>
                <td colspan="1"
                  style="border:none;border-right: 1px solid #000;font-size: 14px; text-align: end;width:0%;"
                  class=" br-right">{{item.pymt_rcv_amt}}</td>
                <td colspan="1" style="border:none;border-right: 1px solid #000;font-size: 14px; text-align: end;"
                  class=" br-right">{{item.remaining_amt}}</td>
              </tr>
            </ng-container>
            <!-- <tr>
                            <td style="border:none" class="br-bottom br-right br-top" style=" font-weight: bold;" colspan="4">Total</td>
                            <td colspan="1" style="border:none; text-align: end;" class=" br-right br-bottom br-top"> {{item1.total_advt_amount}}</td>
                            <td colspan="1" style="border:none; text-align: end;" class=" br-right br-bottom br-top"> {{item1.total_discounted_amt}}</td>
                            <td colspan="1" style="border:none; text-align: end;" class=" br-right br-bottom br-top"> {{item1.rep_name}}</td>
                            <td colspan="1" style="border:none; text-align: end;" class=" br-right br-bottom br-top"> {{item1.total_amt}}</td>
                            <td colspan="1" style="border:none; text-align: end;" class=" br-right br-bottom br-top"> </td>
                            <td colspan="1" style="border:none; text-align: end;" class=" br-right br-bottom br-top"> {{item1.total_rcv}}</td>
                            <td colspan="1" style="border:none; text-align: end;" class=" br-right br-bottom br-top"> {{item1.total_pending}}</td>
                            </tr> -->
            <tr>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: center; font-weight: bold;font-size: 14px;">
                {{item1.advt_data.length}}</td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: center; font-weight: bold;font-size: 14px;" colspan="4">एकूण
              </td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">
                {{item1.total_advt_amount}}</td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{item1.total_amt}}
              </td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">
                {{item1.total_before_gst}}</td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{item1.total_gst}}
              </td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;background-color: #F7BEA2;">
                {{item1.total_discounted_amt}}</td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{item1.total_rcv}}
              </td>
              <td class="br-bottom br-right br-top"
                style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">
                {{item1.total_pending}}</td>
            </tr>
          </ng-container>

          <!-- OFF_REP WISE TOTAL ROW - Added Here -->
          <tr style="background-color: #d3d3d3;">
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: center; font-weight: bold;font-size: 15px;">
              {{item2.total_advt_count}}</td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: center; font-weight: bold;font-size: 15px;" colspan="4">Off-Rep
              एकूण - {{item2.off_rep_name}}</td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 15px;">
              {{item2.total_advt_amount}}</td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 15px;">{{item2.total_amt}}
            </td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 15px;">
              {{item2.total_before_gst}}</td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 15px;">{{item2.total_gst}}
            </td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 15px;background-color: #F7BEA2;">
              {{item2.total_discounted_amt}}</td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 15px;">{{item2.total_rcv}}
            </td>
            <td class="br-bottom br-right br-top"
              style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 15px;">
              {{item2.total_pending}}</td>
          </tr>

        </ng-container>
        <tr>
        </tr>
      </tbody>

      <!-- 18 -->

      <!-- Replace the bottom grand total row with this: -->
      <tr>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: center; font-weight: bold;font-size: 14px;">
          {{inDetailsbriflydata.length}}</td>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: center; font-weight: bold;font-size: 14px;" colspan="4">एकूण</td>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{advtamtb}}</td>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{totaladvtamt}}</td>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align:end; font-weight: bold;font-size: 14px;">{{totalbeforegst_amt}}</td>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{totalgst}}</td>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;background-color: #F7BEA2;">
          {{netadvtamt}}</td>
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{jamatotal}}</td>
        <!-- Fixed: Use jamatotal instead of jamatotalb -->
        <td class="br-bottom br-right br-top"
          style="border: 1px solid #000; text-align: end; font-weight: bold;font-size: 14px;">{{final_pending}}</td>
        <!-- Fixed: Use final_pending -->
      </tr>

    </table>

  </div>
</div>
<div class="noPrint" style="margin-left: 80%; margin-bottom: 2%">
  <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
    (click)="exportexcel('Registration Report')" style="margin-top: 2%;">
    Export
  </button>
  <button style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
    (click)="printPageA4Portrait()">
    Print
  </button>

  <button mat-dialog-close class="btn">Close</button>
</div>